import type { AgentType } from "clippyts/dist/types";

const AGENTS: Record<Uppercase<AgentType>, AgentType> = {
  BONZI: "Bonzi",
  CLIPPY: "Clippy",
  F1: "F1",
  GENIE: "Genie",
  GENIUS: "Genius",
  LINKS: "Links",
  MERLIN: "Merlin",
  PEEDY: "Peedy",
  ROCKY: "Rocky",
  ROVER: "Rover",
};

export default AGENTS;
